module.exports = __webpack_public_path__ + "assets/img/hill-2.872440ae.png";